import { createContext, useContext } from 'react';
import { getPerfArms } from 'src/lib/perf/perfArms';
import { PipeContext } from './Pipe.context';
import type { tFunnel, tPipeContext } from './Pipe.types';

export type tStageMetadata = { id: string; name: string };
export type tBoardFunnel = Pick<tFunnel, 'id' | 'isPublic' | 'fromIndustryTemplate'> & {
  stages?: tStageMetadata[];
};
type tBoardSlice = Pick<tPipeContext,
  'removeLeadFromFunnel' | 'moveLeadToStage' | 'updateLeadAssignee' | 'onLeadTagsChanged' | 'updateLeadAiRespondState' | 'acknowledgeSlbEscalatedLead'
> & {
  currentFunnel: tBoardFunnel | null;
  slbEscalatedLeadIds: ReadonlySet<string>;
  slbAcknowledgedLeadIds: ReadonlySet<string>;
};

export const PipeBoardContext = createContext<tBoardSlice>({
  currentFunnel: null,
  removeLeadFromFunnel: () => {},
  moveLeadToStage: () => {},
  updateLeadAssignee: () => {},
  onLeadTagsChanged: () => {},
  updateLeadAiRespondState: () => {},
  acknowledgeSlbEscalatedLead: () => {},
  slbEscalatedLeadIds: new Set(),
  slbAcknowledgedLeadIds: new Set(),
});
const useTreatmentBoardSlice = () => useContext(PipeBoardContext);
const useControlBoardSlice = () => useContext(PipeContext);
export const useBoardSlice = getPerfArms().effective.perf_s1 === 'treatment'
  ? useTreatmentBoardSlice
  : useControlBoardSlice;
